<template>
  <section class="instagram p-t-20">
      <div class="sec-title p-b-52 p-l-15 p-r-15">
        <h3 class="m-text5 t-center">@ follow us on Instagram</h3>
      </div>

      <div class="flex-w">
        <!-- Block4 -->
        <div class="block4 wrap-pic-w">
          <img src="@/assets/images/gallery-03.jpg" alt="IMG-INSTAGRAM" />

          <a href="#" class="block4-overlay sizefull ab-t-l trans-0-4">
            <span
              class="
                block4-overlay-heart
                s-text9
                flex-m
                trans-0-4
                p-l-40 p-t-25
              "
            >
              <i class="icon_heart_alt fs-20 p-r-12" aria-hidden="true"></i>
              <span class="p-t-2">39</span>
            </span>

            <div class="block4-overlay-txt trans-0-4 p-l-40 p-r-25 p-b-30">
              <p class="s-text10 m-b-15 h-size1 of-hidden">
                Nullam scelerisque, lacus sed consequat laoreet, dui enim
                iaculis leo, eu viverra ex nulla in tellus. Nullam nec ornare
                tellus, ac fringilla lacus. Ut sit amet enim orci. Nam eget
                metus elit.
              </p>

              <span class="s-text9"> Photo by @nancyward </span>
            </div>
          </a>
        </div>

        <!-- Block4 -->
        <div class="block4 wrap-pic-w">
          <img src="@/assets/images/gallery-07.jpg" alt="IMG-INSTAGRAM" />

          <a href="#" class="block4-overlay sizefull ab-t-l trans-0-4">
            <span
              class="
                block4-overlay-heart
                s-text9
                flex-m
                trans-0-4
                p-l-40 p-t-25
              "
            >
              <i class="icon_heart_alt fs-20 p-r-12" aria-hidden="true"></i>
              <span class="p-t-2">39</span>
            </span>

            <div class="block4-overlay-txt trans-0-4 p-l-40 p-r-25 p-b-30">
              <p class="s-text10 m-b-15 h-size1 of-hidden">
                Nullam scelerisque, lacus sed consequat laoreet, dui enim
                iaculis leo, eu viverra ex nulla in tellus. Nullam nec ornare
                tellus, ac fringilla lacus. Ut sit amet enim orci. Nam eget
                metus elit.
              </p>

              <span class="s-text9"> Photo by @nancyward </span>
            </div>
          </a>
        </div>

        <!-- Block4 -->
        <div class="block4 wrap-pic-w">
          <img src="@/assets/images/gallery-09.jpg" alt="IMG-INSTAGRAM" />

          <a href="#" class="block4-overlay sizefull ab-t-l trans-0-4">
            <span
              class="
                block4-overlay-heart
                s-text9
                flex-m
                trans-0-4
                p-l-40 p-t-25
              "
            >
              <i class="icon_heart_alt fs-20 p-r-12" aria-hidden="true"></i>
              <span class="p-t-2">39</span>
            </span>

            <div class="block4-overlay-txt trans-0-4 p-l-40 p-r-25 p-b-30">
              <p class="s-text10 m-b-15 h-size1 of-hidden">
                Nullam scelerisque, lacus sed consequat laoreet, dui enim
                iaculis leo, eu viverra ex nulla in tellus. Nullam nec ornare
                tellus, ac fringilla lacus. Ut sit amet enim orci. Nam eget
                metus elit.
              </p>

              <span class="s-text9"> Photo by @nancyward </span>
            </div>
          </a>
        </div>

        <!-- Block4 -->
        <div class="block4 wrap-pic-w">
          <img src="@/assets/images/gallery-13.jpg" alt="IMG-INSTAGRAM" />

          <a href="#" class="block4-overlay sizefull ab-t-l trans-0-4">
            <span
              class="
                block4-overlay-heart
                s-text9
                flex-m
                trans-0-4
                p-l-40 p-t-25
              "
            >
              <i class="icon_heart_alt fs-20 p-r-12" aria-hidden="true"></i>
              <span class="p-t-2">39</span>
            </span>

            <div class="block4-overlay-txt trans-0-4 p-l-40 p-r-25 p-b-30">
              <p class="s-text10 m-b-15 h-size1 of-hidden">
                Nullam scelerisque, lacus sed consequat laoreet, dui enim
                iaculis leo, eu viverra ex nulla in tellus. Nullam nec ornare
                tellus, ac fringilla lacus. Ut sit amet enim orci. Nam eget
                metus elit.
              </p>

              <span class="s-text9"> Photo by @nancyward </span>
            </div>
          </a>
        </div>

        <!-- Block4 -->
        <div class="block4 wrap-pic-w">
          <img src="@/assets/images/gallery-15.jpg" alt="IMG-INSTAGRAM" />

          <a href="#" class="block4-overlay sizefull ab-t-l trans-0-4">
            <span
              class="
                block4-overlay-heart
                s-text9
                flex-m
                trans-0-4
                p-l-40 p-t-25
              "
            >
              <i class="icon_heart_alt fs-20 p-r-12" aria-hidden="true"></i>
              <span class="p-t-2">39</span>
            </span>

            <div class="block4-overlay-txt trans-0-4 p-l-40 p-r-25 p-b-30">
              <p class="s-text10 m-b-15 h-size1 of-hidden">
                Nullam scelerisque, lacus sed consequat laoreet, dui enim
                iaculis leo, eu viverra ex nulla in tellus. Nullam nec ornare
                tellus, ac fringilla lacus. Ut sit amet enim orci. Nam eget
                metus elit.
              </p>

              <span class="s-text9"> Photo by @nancyward </span>
            </div>
          </a>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: "SectionInstagram"
}
</script>